import React, { useEffect } from 'react';
import { IonRouterOutlet } from '@ionic/react';
import { Redirect, Route, useLocation } from 'react-router';
import { animationSlide } from '../../utils/animation';
import { AnalyticEventsEnum, trackEvent } from '../../Analytics';
import { WHATS_APP_PHONE_NUMBER } from '../../utils/phoneNumber';
import Page from '../../components/Page/Page';

const InstagramRedirectRoutes: React.FC = () => {
  const location = useLocation();

  useEffect(() => {
    let type = '';
    if (location.pathname === '/inst') {
      type = 'base';
    } else if (location.pathname === '/inst/assistance') {
      type = 'assistance';
    } else if (location.pathname === '/inst/whatsapp/contact') {
      type = 'whatsapp_contact';
    } else if (location.pathname === '/inst/whatsapp/concierge') {
      type = 'whatsapp_concierge';
    } else if (location.pathname === '/inst/catalog') {
      type = 'catalog';
    } else {
      // when filtering by ProductCategory was applied
      type = 'catalog_by_product';
    }

    (async function () {
      await trackEvent(AnalyticEventsEnum.REDIRECT_FROM, {
        redirectFrom: 'instagram',
        redirectType: type,
        referrer: document.referrer,
      });
    })();
  }, [location]);

  return (
    <IonRouterOutlet ionPage animation={animationSlide}>
      {/* Landing */}
      <Route exact path="/inst">
        <Redirect to="/" />
      </Route>

      {/* Assistance */}
      <Route exact path="/inst/assistance">
        <Redirect to="/assistance" />
      </Route>

      {/* Catalog Main Page */}
      <Route exact path="/inst/catalog">
        <Redirect to="/catalog" />
      </Route>

      {/* Catalog Main Page */}
      <Route
        exact
        path="/inst/whatsapp/:Variant"
        render={props => {
          const variant = props.match.params.Variant as string;
          let text = '';
          if (variant === 'contact') {
            text = 'Hello, ';
          } else if (variant === 'concierge') {
            text = 'Hello, I want you to organize my event';
          }

          window.location.replace(
            `https://wa.me/${WHATS_APP_PHONE_NUMBER}?text=${encodeURI(text)}`
          );
          return <Page />;
        }}
      />

      {/* Catalog Specific Service */}
      <Route
        exact
        path="/inst/catalog/:ProductCategoryName"
        render={props => (
          <Redirect
            to={`/catalog?type=product&product_category_id=${props.match.params.ProductCategoryName}`}
          />
        )}
      />
    </IonRouterOutlet>
  );
};

export default React.memo(InstagramRedirectRoutes);
